import React, { useState, useEffect } from 'react';
import UserSearch from '../../API/UserSearch';
import resx from '../../utilities/resx';
import _path from 'ramda/src/path';
import { RESX_GLOBAL } from '../../Constants';
import LogglyLogger from '../../API/Loggly';
import { LOGGLY_LEVEL_ERROR } from '../../Constants';
import Image from './Image';

const UserMention = ({ inputValue, setInputValue, inputRef }) => {
    const [searchResults, setSearchResults] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    useEffect(
        () => {
            const debounceTimeout = 300;
            let debounceTimer;
            const handleKeyPress = event => {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(() => {
                    const cursorPosition = inputRef.current.selectionStart;
                    const inputText = inputRef.current.value;

                    const lastAtIndex = inputText.lastIndexOf('@', cursorPosition - 1);
                    if (lastAtIndex !== -1) {
                        const textAfterAt = inputText.substring(lastAtIndex + 1, cursorPosition);
                        if (!/\s/.test(textAfterAt)) {
                            if (textAfterAt) {
                                const query = { SearchFor: textAfterAt };
                                UserSearch.mention(query)
                                    .request.then(response => {
                                        if (!_path(['data', 'Success'], response)) {
                                            throw new Error(response.data);
                                        }
                                        if (_path(['data', 'Data'], response)) {
                                            setSearchResults(response.data.Data);
                                            setShowSuggestions(true);
                                        } else {
                                            setShowSuggestions(false);
                                        }
                                    })
                                    .catch(error => {
                                        LogglyLogger.add(
                                            LOGGLY_LEVEL_ERROR,
                                            'UserMention.mention via UserMention component',
                                            error
                                        );
                                        setShowSuggestions(false);
                                    });
                            }
                        } else {
                            setShowSuggestions(false);
                        }
                    } else {
                        setShowSuggestions(false);
                    }
                }, debounceTimeout);
            };

            inputRef.current.addEventListener('input', handleKeyPress);

            return () => {
                if (inputRef.current) {
                    inputRef.current.removeEventListener('input', handleKeyPress);
                }
            };
        },
        [inputValue, inputRef]
    );

    const handleUserSelect = domian => {
        const atIndex = inputValue.lastIndexOf('@', inputRef.current.selectionStart - 1);
        const cursorPosition = inputRef.current.selectionStart;

        const newValue = `${inputValue.slice(0, atIndex + 1)}${domian}${inputValue.slice(cursorPosition)}`;
        const newCursorPosition = atIndex + domian.length + 1;
        setInputValue(newValue);
        setShowSuggestions(false);
        inputRef.current.focus();
        setTimeout(() => {
            inputRef.current.setSelectionRange(newCursorPosition, newCursorPosition);
        }, 0);
    };

    return (
        <div>
            {showSuggestions && (
                <ul className="re-usermention-items">
                    {searchResults.length > 0 ? (
                        searchResults.map((user, index) => (
                            <li
                                className="re-usermention-item"
                                key={index}
                                onClick={() => handleUserSelect(user.Domain)}
                                data-testid="usermentionitem"
                            >
                                <Image
                                    src={user.ProfileImageUrl}
                                    alt={`${user.Firstname} ${user.Lastname}`}
                                    width={30}
                                    className="re-avatar-xxs"
                                />
                                <span>{`${user.Firstname} ${user.Lastname}`}</span>
                            </li>
                        ))
                    ) : (
                        <li className="re-usermention-no-found" data-testid="notfound">
                            {resx(RESX_GLOBAL, 'USERMENTION_NO_USERS_FOUND')}
                        </li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default UserMention;
